// LocationAutocomplete.js
import React,{useState} from 'react';

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import {
    AppInputField
} from './../../../../../widget/styledComponents/input_field.style'

const LocationAutocomplete = ({ onSelect }) => {
  const handleSelect = async (address,placeId) => {
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      onSelect(
        latLng, 
        address,
        results[0].address_components.find(component => component.types.includes('country')).long_name,
        results[0].address_components.find(component => component.types.includes('administrative_area_level_1')).long_name,
        results[0].address_components.find(component => component.types.includes('locality')).long_name
      );
    } catch (error) {
      console.error('Error while fetching location details:', error);
    }
  };
  const [address, setAddress] = useState('');
  return (
    <PlacesAutocomplete
      value={address}
      onChange={setAddress}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <AppInputField
            {...getInputProps({
              placeholder: 'Enter a location',
              className: 'location-input',
            })}

            required
          />
          <div className="autocomplete-dropdown-container collection" >
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? 'suggestion-item--active collection-item'
                : 'suggestion-item collection-item';
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                  })}
                >
                  <span>{suggestion.description}</span>

                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default LocationAutocomplete;
